import { render } from "./Classe.vue?vue&type=template&id=5c0dbe29&scoped=true"
import script from "./Classe.vue?vue&type=script&lang=js"
export * from "./Classe.vue?vue&type=script&lang=js"

import "./Classe.vue?vue&type=style&index=0&id=5c0dbe29&scoped=true&lang=css"

import exportComponent from "C:\\Users\\pc\\Documents\\projets\\school_app_front_novation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c0dbe29"]])

export default __exports__